/**
 * Whether today's day book was printed in this browser — the one Close the day step the books
 * cannot answer (core `cash/closeDay.ts`). A per-browser convenience, so `localStorage`, and every
 * read and write forgives a blocked store: the step then simply stays open.
 */
const keyFor = (branchId: number) => `attirerent.cash.dayBookPrinted.${branchId}`;

export function dayBookPrintedOn(branchId: number | undefined, day: string): boolean {
  if (branchId === undefined) {
    return false;
  }

  try {
    return window.localStorage.getItem(keyFor(branchId)) === day;
  } catch {
    return false;
  }
}

export function markDayBookPrinted(branchId: number | undefined, day: string): void {
  if (branchId === undefined) {
    return;
  }

  try {
    window.localStorage.setItem(keyFor(branchId), day);
  } catch {
    // A blocked store leaves the step open, which is the honest answer.
  }
}
